import React from 'react';
import {Button, Heading, Img, ListItem, UnorderedList,Text} from "@chakra-ui/react";
import styles from "./ProductsCard.module.css";
import ReactStars from 'react-stars';
import axios from "axios";
import base_url from "../utils/getlink";

const addtocart = (data)=>{
    return axios({
        method:'post',
        url:`${base_url}/cart/create`,
        data:data,
        headers:{
            'authorization':`Bearer ${localStorage.getItem('token')}`
        }
    });
}
const getCartItem = (id)=>{
    return axios({
        method:'get',
        url:`${base_url}/cart/${id}`
    });
}

const ProductCard = ({props}) => {
    const handleAddToCart=(id)=>{
        
        const data={
            Itembaseprice:props.price||250,
            Itemqty:1,
            productId:id,
            Itemdiscount:props.discount||0,
            orderPlaced:false
        }
        addtocart(data).then((res)=>{
            getCartItem(res.data.cartItemId).then((resp)=>{
                console.log(resp.data.data);
                axios({
                    method:'patch',
                    url:`${base_url}/users/update/cart/${res.data.userId}`,
                    data:{cart:resp.data.data[0]},
                    headers:{
                        'authorization':`Bearer ${localStorage.getItem('token')}`
                    }
                }).then((respo)=>{console.log('success.',respo.data.message);alert('added to cart successfully.')}).catch((e)=>{console.log('error',e)});
            }).catch((e)=>{
                console.log(e);
            })
            
        }).catch((e)=>{
            console.log(e);
            alert('something went wrong.');
        })
    }
  return (
    <div className={styles.main}>
        <div>
        <Heading size='md'>
            {props.title}
        </Heading>
        {props.price&&<Text paddingTop={'7px'}>&#8377;{props.price}</Text>}
        <div style={{display:"flex"}}>
        
        <ReactStars count={5} value={Number(props.rating)} activeColor="#ffd700" edit={false} size={24}/>
        <Text paddingTop={'7px'}>{props.rating}</Text><br/>
        <Text paddingTop={'7px'}>{props.ratingCount}</Text>
        </div>
        <hr/>
        <UnorderedList marginLeft={'50px'}>
        {props.description.map((el,i)=>{
            return <ListItem key={i}>{el}</ListItem>
        })}
        </UnorderedList>
        
        <hr/><br/>
        <Button onClick={()=>handleAddToCart(props._id)}>Add to Cart</Button>
        {/* <Button>Add to Cart</Button> */}
        </div>
        <div>
            <Img src={props.image||'/images/GS.png'} alt={props.title} width={'100%'} height={'200px'} loading={'lazy'}/>
        </div>
    </div>
  )
}

export default ProductCard